export default __webpack_public_path__ + "static/media/success.8374295b.png";